import { AuthManager } from '@voiapp/voi.web.authentication'
import { ins } from 'src/api/axios'
import { auth } from 'src/firebase/firebase'

export const authManager = new AuthManager(auth, ins)
